import React from 'react';
import PropTypes from 'prop-types';
import {
  analyticsTrack,
  EVENT_OBJECT,
  EVENT_VERB,
  eventBuilder,
} from '../utils/tracking';

const OutboundLink = (props) => {
  const { eventName, eventLabel, eventParams, onClick, ...rest } = props;
  // These vars are used on <a/> as well as inside onClick()
  const { target, href } = rest;

  return (
    <a
      {...rest}
      onClick={(e) => {
        if (typeof onClick === `function`) {
          onClick(e);
        }

        let redirect = true;
        if (
          e.button !== 0 ||
          e.altKey ||
          e.ctrlKey ||
          e.metaKey ||
          e.shiftKey ||
          e.defaultPrevented
        ) {
          redirect = false;
        }

        if (target && target.toLowerCase() !== `_self`) {
          redirect = false;
        }

        analyticsTrack({
          event:
            eventName ||
            eventBuilder(EVENT_OBJECT.button, EVENT_VERB.interacted),
          params: {
            label: eventLabel?.trim() || 'Outbound',
            to: href,
            element_type: 'OutboundLink',
            transport: redirect ? `beacon` : ``,
            ...eventParams,
          },
        });

        if (redirect) {
          document.location = href;
        }

        return false;
      }}
    />
  );
};

OutboundLink.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  eventLabel: PropTypes.string,
  eventName: PropTypes.string,
  eventParams: PropTypes.object,
  onClick: PropTypes.func,
};

OutboundLink.defaultProps = {
  href: null,
  target: null,
  eventLabel: null,
  eventName: null,
  eventParams: {},
  onClick: null,
};

export default OutboundLink;
